"use client";

import RenderUserAvatar from "../../../common/RenderUserAvatar";
import { userIcon } from "../../../../assets";
import { useAuth } from "../../../../lib/services/auth-session-service";
import { useIpDetails } from "../../../../lib/services/location-service";
import { getLoggedinUser } from "../../../../lib/util";
import { useAppDispatch, useAppSelector } from "../../../slice/hooks";
import { getActiveUser, logOutUser, logTempToken } from "../../../slice/auth-slice";
import { useHistoryManager } from "../../../history/useHistoryManager";
import Dropdown from "../../../dropdown/Dropdown";

const UserLoginSwitch = ({
  onLogout,
  handleLoginClick,
  dropdownMode = false,
  storePath,
}) => {
  const dispatch = useAppDispatch();
  const { data: ipDetails, isSuccess } = useIpDetails();

  const { loggedInUser } = useAppSelector((state) =>
    getActiveUser(state, getLoggedinUser()),
  );

  const { logUserOut } = useAuth();
  const { navigateTo } = useHistoryManager(storePath);

  const handleLogout = async () => {
    dispatch(logOutUser());
    const geo = isSuccess ? ipDetails : null;
    const { token, tokenExpiryDate } = await logUserOut(geo);
    dispatch(logTempToken({ token, tokenExpiryDate }));
    onLogout?.();
  };

  const handleProfileClick = () => {
    navigateTo("profile/account", { urlData: { subPath: "account" } });
  };

  const handleOrderClick = () => {
    navigateTo("profile/orders", { urlData: { subPath: "orders" } });
  };

  const menuOptions = [
    { key: "profile", label: "Profile", action: handleProfileClick },
    { key: "orders", label: "Orders", action: handleOrderClick },
    { key: "logout", label: "Logout", action: handleLogout },
  ];

  const renderUserSection = () => {
    if (!dropdownMode) {
      return (
        <div className="user-info">
          <RenderUserAvatar user={loggedInUser.user} />
          <span className="user-greeting desktop-only">
            Hi, {loggedInUser.user.firstName || "User"}
          </span>
          <span className="logout-link" onClick={handleLogout}>
            Logout
          </span>
        </div>
      );
    }

    return (
      <Dropdown
        options={menuOptions}
        value={null}
        getOptionValue={(opt) => opt.key}
        getOptionLabel={(opt) => opt.label}
        onSelect={(opt) => opt.action()}
        className="user-info-dropdown"
      >
        <div className="user-info">
          <RenderUserAvatar user={loggedInUser.user} />
          <span className="user-greeting desktop-only">
            Hi, {loggedInUser.user.firstName || "User"}
          </span>
        </div>
      </Dropdown>
    );
  };

  const renderGuestSection = () => (
    <>
      <div className="login-button desktop-only" onClick={handleLoginClick}>
        Login / Sign Up
      </div>
      <div className="user-profile mobile-only" onClick={handleLoginClick}>
        {userIcon}
      </div>
    </>
  );

  return (
    <div className="user-login-switch">
      {loggedInUser?.user ? renderUserSection() : renderGuestSection()}
    </div>
  );
};

export default UserLoginSwitch;
